module.exports = __webpack_public_path__ + "static/media/camera-alt.642ae28a.svg";